<template>
    <e-dialog
            dialogTitle="驳回原因记录"
            :centerDialogVisible="visible"
            :popupWidth="'800px'"
            @resetPopupData="resetPopupData"
            @submitPopupData="submitPopupData"
            >
        <div>
            <TableList
                    :table-data="tableData"
                    :table-label="tableLabel">
                <template v-slot:showIndex="slot">
                    <span>{{ (queryData.pageNum - 1) * queryData.pageSize + slot.scope.$index + 1 }}</span>
                </template>
            </TableList>
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="queryData.pageNum"
                        :page-size="queryData.pageSize"
                        :total="queryData.pageTotal"
                        prev-text="上一页"
                        next-text="下一页"
                ></el-pagination>
            </div>
        </div>

    </e-dialog>
</template>

<script>
    import eDialog from "../../../components/common/e-dialog.vue";
    import TableList from '../../../components/common/e-table-list';
    import api from "../../../api/cms/index";
    export default {
        name: "reasonDialog",
        components:{eDialog,TableList},
        props:{
            visible:Boolean,
            id:Number,
        },
        data(){
            return{
                queryData:{
                    pageNum:1,
                    pageSize:10,
                    pageTotal:0,
                },
                tableData:[],
                tableLabel: [
                    {label: "序号", slot: "showIndex", align: "center", width: '80'},
                    {label: "审核人部门",  align: "center", param:'department'},
                    {label: "审核人",  align: "center", param:'auditBy'},
                    {label: "审核时间",  align: "center", param:'auditTime' },
                    {label: "邮箱", align: "center", param:'email'},
                    {label: "电话", align: "center", param:'telephone'},
                    {label: "驳回原因",  align: "center",param:'comments' },
                ]
            }
        },
        methods:{
            resetPopupData(){
                this.$emit('closeDialog');
            },
            submitPopupData(){
                this.$emit('closeDialog');
            },
            handleSizeChange(val) {
                this.queryData.pageNum = 1;
                this.queryData.pageSize = val;
                this.querySignAuditReason();
            },
            handleCurrentChange(val) {
                this.queryData.pageNum = val;
                this.querySignAuditReason();
            },
            async querySignAuditReason(){
                let res = await api.querySignAuditReason({activityId:this.id})
                if (res.code === '200') {
                    this.tableData = res.data.records || [];
                    this.queryData.pageTotal = res.data.total || 0;
                }
            },
        },
        mounted() {
            this.querySignAuditReason();
        }
    }
</script>

<style scoped lang="scss">

</style>